import { z } from "zod";

export const GetMeditationDailyExampleUrlSchema = z.object({
  meditationDailyId: z.string().min(1),
});

export type GetMeditationDailyExampleUrlPostBody = z.infer<typeof GetMeditationDailyExampleUrlSchema>;
